<template>
  <div class="user-input">
    <div
      ref="header"
      class="booking-header-extension"
    >
      <div
        class="booking-header-close"
        data-component="booking-header-close"
      >
        <span
          class="icon-close"
          aria-hidden="true"
          tabindex="0"
          :aria-label="tc('booking.close')"
          @click="deactivate"
        />
      </div>
      <div class="booking-header-extension-wrapper container">
        <div class="booking-header-extension-left">
          <div
            v-if="enhancement.name"
            class="title"
          >
            {{ enhancement.name }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="enhancements-wrapper"
      :style="[{ height: scrollHeight + 'px' }]"
    >
      <component
        :is="inputComponent"
        ref="input"
        :enhancement="enhancement"
        :data="value.data"
        @is-valid="isValid = $event"
      />
    </div>
    <div
      ref="footer"
      class="booking-footer"
    >
      <div class="booking-footer-wrapper container">
        <button
          :disabled="!isValid"
          :class="[{ loading: cartPending }]"
          @click="updateValue"
        >
          {{ tc('enhancements.addToStay') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import TabTrapMixin from '@mixins/tab-trap'
  import Tracking from '@mixins/tracking'
  import { ENHANCEMENT_USER_INPUTS } from '@utils/constants'
  import CelebratoryTreat from './user-inputs/celebratory-treat.vue'
  import PreferredTime from './user-inputs/preferred-time.vue'

  export default {
    name: 'EnhancementUserInput',
    mixins: [TabTrapMixin, Tracking],
    props: {
      value: {
        type: Object,
        required: true
      },
      outerActivator: HTMLElement,
    },
    data: () => ({
      scrollHeight: 'auto',
      isValid: false,
      componentTypes: {
        [ENHANCEMENT_USER_INPUTS.EARLY_CHECK_IN]: PreferredTime,
        [ENHANCEMENT_USER_INPUTS.LATE_CHECK_OUT]: PreferredTime,
        [ENHANCEMENT_USER_INPUTS.CELEBRATORY_TREAT]: CelebratoryTreat
      }
    }),
    computed: {
      ...mapState('responsive', ['height']),
      ...mapGetters('i18n', ['tc']),
      ...mapGetters('booking', ['bookingFlow']),
      ...mapState('cart', ['roomEnhancements', 'cartPending']),
      ...mapState('modifyReservation', ['isBookingEditMode']),
      inputComponent() {
        return this.componentTypes[this.value.userInput]
      },
      noInitialFocus() {
        return false
      },
      enhancement() {
        return this.roomEnhancements.find((e) => this.value.sitecoreId === e.sitecoreId)
      },
    },
    watch: {
      height() {
        this.calculateScroll()
      }
    },
    created() {
      if (!this.value.data) {
        this.$emit('input', {
          ...this.value,
          data: {}
        })
      }
    },
    mounted() {
      this.calculateScroll()

      document.querySelector('body').style.overflowY = 'hidden'

      this.$track(this.getTrackingData(this.isBookingEditMode ? 'modifyReservation' : 'booking', undefined, {
        event: 'bookingStateChange',
        bookingEngine: {
          bookingStepNumber: this.isBookingEditMode ? '2.4' : '3.4',
          bookingStepName: 'Enhancements Detail',
          bookingEngineVersion: this.isBookingEditMode ? '2' : '1',
          bookingFlow: this.bookingFlow()
        }
      }))
    },
    methods: {
      updateValue() {
        this.$track(this.getTrackingData(this.isBookingEditMode ? 'modifyReservation' : 'booking', undefined, {
          event: 'bookingStateChange',
          bookingEngine: {
            bookingStepNumber: this.isBookingEditMode ? '2.5' : '3.5',
            bookingStepName: 'Enhancements Confirmation',
            bookingEngineVersion: this.isBookingEditMode ? '2' : '1',
            bookingFlow: this.bookingFlow()
          }
        }))

        this.$emit('input', {
          ...this.value,
          data: {
            ...this.$refs.input.$data
          }
        })
        document.querySelector('body').style.overflowY = 'auto'
        this.$emit('done')
      },
      deactivate() {
        document.querySelector('body').style.overflowY = 'auto'
        this.$emit('deactivate')
      },
      closeModal() {
        this.deactivate()
      },
      calculateScroll() {
        const headerHeight = this.$refs.header?.getBoundingClientRect().height ?? 0
        const footerHeight = this.$refs.footer?.getBoundingClientRect().height ?? 0
        this.scrollHeight = this.height - headerHeight - footerHeight
      },
    },
  }
</script>
